import * as React from 'react';
import {Svg, 
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';

const DinerClubCard = props => {
  return (
    <Svg
      width={46}
      height={30}
      viewBox="0 0 46 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        clipPath="url(#clip0_24105_13388)"
        fillRule="evenodd"
        clipRule="evenodd">
        <Path
          d="M.896 2.116C.896.95 1.843.002 3.011.002h40.875C45.053.002 46 .949 46 2.116v25.37a2.114 2.114 0 01-2.114 2.115H3.01a2.114 2.114 0 01-2.115-2.114V2.117z"
          fill="#F4F6F7"
        />
        <Path
          d="M.896 1.502a1.5 1.5 0 011.5-1.5h29a1.5 1.5 0 011.5 1.5v18a1.5 1.5 0 01-1.5 1.5h-29a1.5 1.5 0 01-1.5-1.5v-18z"
          fill="#E5E5E5"
          fillOpacity={0.01}
        />
        <Path
          d="M25.3 21.819c3.81.018 7.287-3.136 7.287-6.972 0-4.196-3.478-7.096-7.288-7.095H22.02c-3.855-.001-7.029 2.9-7.029 7.095 0 3.837 3.174 6.99 7.03 6.972h3.278z"
          fill="url(#paint0_linear_24105_13388)"
        />
        <Path
          d="M22.034 8.338c-3.523.001-6.378 2.883-6.38 6.44.002 3.556 2.857 6.437 6.38 6.438 3.524-.001 6.38-2.883 6.38-6.439s-2.856-6.438-6.38-6.44zm-4.044 6.44a4.087 4.087 0 012.596-3.81v7.618a4.085 4.085 0 01-2.596-3.808zm5.491 3.81v-7.62a4.085 4.085 0 012.597 3.81 4.086 4.086 0 01-2.597 3.81z"
          fill="#F4F6F7"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_24105_13388"
          x1={36.2382}
          y1={19.1268}
          x2={31.7257}
          y2={4.37984}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#009BE0" />
          <Stop offset={1} stopColor="#006BA8" />
        </LinearGradient>
        <ClipPath id="clip0_24105_13388">
          <Path
            fill="#fff"
            transform="translate(.896)"
            d="M0 0H45.1034V29.5991H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default DinerClubCard;
